import { ClienteVM } from './../../../_entities/clientes/ClienteVM';
import { PlanTarifarioI } from './../../../_entities/sims/PlanTarifario';
import { TelefoniaI } from './../../../_entities/sims/Telefonia';
import { Observable } from 'rxjs';
import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SimVM } from './../../../_entities/sims/SimVM';

@Injectable({
  providedIn: 'root'
})
export class SimService {

  constructor(private http: HttpClient) { }

  obtenerSims(): Observable<SimVM[]>{
    return this.http.get<SimVM[]>(`${environment.API_SECURITY}/api/sims`);
  }

  obtenerSimsDisponibles(): Observable<SimVM[]>{
    return this.http.get<SimVM[]>(`${environment.API_SECURITY}/api/sims/disponibles`);
  }

  obtenerSimId(simId): Observable<SimVM> {
    return this.http.get<SimVM>(`${environment.API_SECURITY}/api/sims/${simId}`);
  }

  obtenerTelefonias(): Observable<TelefoniaI[]> {
    return this.http.get<TelefoniaI[]>(environment.API_SECURITY + '/api/Sims/telefonias');
}

  obtenerPlanesTarifarios(): Observable<PlanTarifarioI[]> {
    return this.http.get<PlanTarifarioI[]>(environment.API_SECURITY + '/api/Sims/planestarifarios');
  }

  obtenerClientes(incluirClientePropietario: boolean = false): Observable<ClienteVM[]> {
    return this.http.get<ClienteVM[]>(`${environment.API_SECURITY}/api/Reportes/ClientesReportes`);
  }

  guardarSim(form): Observable<any>{
    return this.http.post<any>(`${environment.API_SECURITY}/api/Sims`, form);
  }

  actualizarSim(form, simId): Observable<any>{
    return this.http.put<any>(`${environment.API_SECURITY}/api/sims/${simId}`, form);
  }

  eliminarSims(simId): Observable<any> {
    return this.http.delete<any>(`${environment.API_SECURITY}/api/sims/${simId}`);
  }
}
